<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'CareersDetail',

    metaInfo: { title: 'Detail Karir' },

    extends: View,

    mixins: [
      LoadSections([
        'careers-detail',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'careersdetail',
      },
    },
  }
</script>
